// generated by srcset-codegen
import src from "./postal-fun-logo.svg";

const width = 256;
const height = 29;
export default { src, width, height };
